 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-avatar_3-ios-entry-js","9":"stencil-ion-avatar_3-md-entry-js","10":"stencil-ion-back-button-ios-entry-js","11":"stencil-ion-back-button-md-entry-js","12":"stencil-ion-backdrop-ios-entry-js","13":"stencil-ion-backdrop-md-entry-js","14":"stencil-ion-card_5-ios-entry-js","15":"stencil-ion-card_5-md-entry-js","16":"stencil-ion-checkbox-ios-entry-js","17":"stencil-ion-checkbox-md-entry-js","18":"stencil-ion-chip-ios-entry-js","19":"stencil-ion-chip-md-entry-js","20":"stencil-ion-col_3-entry-js","21":"stencil-ion-img-entry-js","22":"stencil-ion-infinite-scroll_2-ios-entry-js","23":"stencil-ion-infinite-scroll_2-md-entry-js","24":"stencil-ion-input-ios-entry-js","25":"stencil-ion-input-md-entry-js","26":"stencil-ion-loading-ios-entry-js","27":"stencil-ion-loading-md-entry-js","28":"stencil-ion-popover-ios-entry-js","29":"stencil-ion-popover-md-entry-js","30":"stencil-ion-progress-bar-ios-entry-js","31":"stencil-ion-progress-bar-md-entry-js","32":"stencil-ion-radio_2-ios-entry-js","33":"stencil-ion-radio_2-md-entry-js","34":"stencil-ion-reorder_2-ios-entry-js","35":"stencil-ion-reorder_2-md-entry-js","36":"stencil-ion-ripple-effect-entry-js","37":"stencil-ion-spinner-entry-js","38":"stencil-ion-split-pane-ios-entry-js","39":"stencil-ion-split-pane-md-entry-js","40":"stencil-ion-tab-bar_2-ios-entry-js","41":"stencil-ion-tab-bar_2-md-entry-js","42":"stencil-ion-tab_2-entry-js","43":"stencil-ion-text-entry-js","44":"stencil-ion-textarea-ios-entry-js","45":"stencil-ion-textarea-md-entry-js","46":"stencil-ion-toggle-ios-entry-js","47":"stencil-ion-toggle-md-entry-js","48":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"93d0a615","1":"592e91cf","2":"cc200047","3":"30efd0c3","4":"5c1226ae","5":"7ebf3305","8":"d80bde04","9":"7dfe2c4e","10":"d8acea2d","11":"30808ae4","12":"ca32429f","13":"c9ed0b6c","14":"be770bf2","15":"7819d86e","16":"7746ab9f","17":"18024c24","18":"f3610470","19":"50544eee","20":"9cd71be8","21":"52a92da1","22":"c1c4d92b","23":"cb9e22fb","24":"23f445a0","25":"bd6e7e2f","26":"5c32e4c5","27":"3834b2f7","28":"e1e14fe1","29":"48642a16","30":"021e0fe2","31":"df7b2ae4","32":"953161e3","33":"a759b1f2","34":"0c430de2","35":"efc9cd7c","36":"67509769","37":"a9aeedca","38":"791b830c","39":"a35638ac","40":"75f92b64","41":"770bf80a","42":"5453bd49","43":"df9b9f7d","44":"820b40a9","45":"515c6122","46":"e4d90ce7","47":"6473b73b","48":"ee12ed03","50":"8e573f56","51":"a3f3dec1","52":"7c036714","53":"38185568","54":"3a22198e","55":"176ac97f","56":"71416179","57":"cf033f38","58":"6b75b3b4","59":"2d6816a6","60":"cfa4eae6","61":"56e908cb","62":"03fa62c1","63":"409e7bb4","64":"daf07453","65":"57b3d939","66":"b42ec58e","67":"651f4c07","68":"4b4810f2","69":"0d35ac28","70":"df9497fb","71":"7d4c0417","72":"861cb17e","73":"4766e76c","74":"514e0c3e","75":"6a05a00c","76":"8f18a721","77":"12e5625a","78":"785d0f41","79":"a5772c50","80":"bc4d389d","81":"da7dd7e9","82":"4b165f8c","83":"032f2460","84":"7a39b053","85":"6b8bed90","86":"9292cd36","87":"26e557f7","88":"5a390165","89":"512c7832","90":"99004278","91":"112facbd"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpionic-react-swipegesture-issue"] = this["webpackJsonpionic-react-swipegesture-issue"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
